import { Component, EventEmitter, Input, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { AppDataService, ConfigService, QuestService } from 'app/services';
import { Utils } from 'app/utils';
import { AppComponent } from 'app/app.component';
import {ExportFileTypeModel} from 'app/models';
import moment from 'moment/moment';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { FieldTypeEnum } from 'app/models';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import { TableLazyLoadEvent } from 'primeng/table';

enum TimeSliceEnum {
    EarlyBird = 1,
    HolidayRush = 2,
    YearEndCraze = 3,
    GrandPrize = 4
}

@Component({
    selector: 'customer-quest',
    templateUrl: './customer-quest.component.html',
    styleUrls: ['./customer-quest.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class CustomerQuestComponent implements OnInit, AfterViewInit  {
    @Input()
    public menuPermissionActive!: string;

    @Output() changedVisibleExportSidebarEmit = new EventEmitter<boolean>();
    changedVisibleExportSidebar(increased: any) {
        this.changedVisibleExportSidebarEmit.emit(increased);
    }

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    private readonly ONE_DAY = 1;
    private readonly SEVEN_DAYS = 7;
    private readonly ONE_MONTH = 28;
    private readonly TWO_MONTH = 56;

    private readonly EARLY_BIRD = 13;
    private readonly HOLIDAY_RUSH = 22;
    private readonly YEARLY_END_CRAZE = 14;
    private readonly GRAND_PRIZE = 48;

    showFinishRaffleSidebar: boolean = false;
    showExportSidebar: boolean = false;

    selectedQuest: any;
    quests: Array<any> = [];
    searchName: string = '';
    winners: Winner[] = [{Id: 1, Name: '', TicketNumber: '', Prize: ''} as Winner];
    newWinnerID: number = 1;
    isDraw: boolean = false;
    formDisabled: boolean = false;
    finishRaffleHeader: string = '';
    finishRaffleMsg: string = '';
    fileName: string = '';

    exportData: any = {};
    timeSlice: TimeSliceEnum = TimeSliceEnum.EarlyBird;
    datesList: Array<any> = [];
    daysList: Array<any> = [];
    weeksList: Array<any> = [];
    monthsList: Array<any> = [];
    selectedDate: any;

    menuTabItems: MenuItem[] = [
        { label: 'Early Bird', command: (e: any) => { this.switchTab(e.item, 0, false); } },
        { label: 'Holiday Rush', command: (e: any) => { this.switchTab(e.item, 0, false); } },
        { label: 'Year-End Craze', command: (e: any) => { this.switchTab(e.item, 0, false); } },
        { label: 'Grand Prize', command: (e: any) => { this.switchTab(e.item); }},
    ];
    activeTabItem: MenuItem = { label: 'Early Bird' };

    cols = [
        { field: 'Name', header: 'Name', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'name', active: false },
        { field: 'ContactNumber', header: 'Contact Number', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'contactNumber', active: false },
        { field: 'Email', header: 'Email', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'email', active: false },
        { field: 'TicketNumber', header: 'Ticket Number', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'ticketNumber', active: false },
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    rowsPerPage: number = 14;
    totalRecords: number = -1;

    fieldTypeEnum = FieldTypeEnum;
    txnHeaderSearch: any = {
        name: null,
        contactNumber: null,
        email: null,
        ticketNumber: null,

        selectedDay: null,
        startDate: null,
        endDate: null,
    };

    first: number = 0;
    sortField: string | string[] = '';
    sortOrder: number = 1;

    loading: boolean = true;
    exportLoading: boolean = false;
    searchTimer: number = 0;
    tableName = EditTableConfig.CUSTOMER_QUEST;

    constructor(
        private messageService: MessageService,
        private questService: QuestService,
        public configService: ConfigService,
        public app: AppComponent,
        public appData: AppDataService) {
    }

    ngOnInit(): void {
        this.questService.getQuestDates(this.messageService)
            .then(data => {
                this.activeTabItem = this.menuTabItems[0];
                this.switchTab(this.activeTabItem);
            });

    }

    ngAfterViewInit() {
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        if (!this.cols.length || !this.activeTabItem.command) {
            return;
        }

        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Name';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getQuests(this.getRequestDto(skip));
    }

    switchTab(menuItem: MenuItem, skip: number = 0, dateChange: boolean = true) {
        this.setFinishText(menuItem.label+'');
        switch (menuItem.label) {
            case 'Early Bird':
                this.timeSlice = TimeSliceEnum.EarlyBird;
                this.activeTabItem = this.menuTabItems[0];
                this.selectedDate = new Date(2024, 10, 18);
                break;
            case 'Holiday Rush':
                this.timeSlice = TimeSliceEnum.HolidayRush;
                this.activeTabItem = this.menuTabItems[1];
                this.selectedDate = new Date(2024, 11, 1);
                break;
            case 'Year-End Craze':
                this.timeSlice = TimeSliceEnum.YearEndCraze;
                this.activeTabItem = this.menuTabItems[2];
                this.selectedDate = new Date(2024, 11, 23);
                break;
            case 'Grand Prize':
                this.timeSlice = TimeSliceEnum.GrandPrize;
                this.activeTabItem = this.menuTabItems[3];
                this.selectedDate = new Date(2024, 10, 18);
                break;
        }

        this.winners = [{Id: 1, Name: '', TicketNumber: '', Prize: ''} as Winner];
        this.formDisabled = true;
        this.quests = [];

        this.onDateChanged(skip);
    }

    onDateChanged(skip = 0) {
        this.setDatesRange();
        this.getQuests(this.getRequestDto(skip));
        this.isWinnerChosen();
    }

    setDatesRange() {
        this.setDefaultSelectedDate();
        switch (this.timeSlice) {
            case TimeSliceEnum.EarlyBird:
                this.setDates(this.EARLY_BIRD);
                this.fileName = 'Early-Bird_'+moment(this.selectedDate).format('DDMMYY')+'-'
                    +moment(this.selectedDate).add(this.EARLY_BIRD,'days').format('DDMMYY')+'_tickets';
                break;
            case TimeSliceEnum.HolidayRush:
                this.fileName = 'Holiday-Rush_'+moment(this.selectedDate).format('DDMMYY')+'-'
                    +moment(this.selectedDate).add(this.HOLIDAY_RUSH,'days').format('DDMMYY')+'_tickets';
                this.setDates(this.HOLIDAY_RUSH);
                break;
            case TimeSliceEnum.YearEndCraze:
                this.fileName = 'Year-End-Craze_'+moment(this.selectedDate).format('DDMMYY')+'-'
                    +moment(this.selectedDate).add(this.YEARLY_END_CRAZE,'days').format('DDMMYY')+'_tickets';
                this.setDates(this.YEARLY_END_CRAZE);
                break;
            case TimeSliceEnum.GrandPrize:
                this.fileName = 'grandwinner_tickets';
                this.setDates(this.GRAND_PRIZE);
                break;
        }
    }

    setDates(daysAmount: number) {
        this.txnHeaderSearch.startDate = this.selectedDate;
        this.txnHeaderSearch.endDate = moment(this.selectedDate).add(daysAmount, 'days');
    }

    setDefaultSelectedDate() {
        if (!this.selectedDate && this.datesList[0]) {
            this.selectedDate = this.datesList[0].value;
        }
    }

    setFinishText(text: string) {
        this.finishRaffleHeader = text;
        this.finishRaffleMsg = text.toLowerCase();
    }

    finishRaffle(){
        if (!this.validateWinners()) {
            return;
        }

        const dto = {
            TimeSlice: this.timeSlice,
            Winners: this.winners
        };
        this.questService.finishRaffle(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'The '+ this.finishRaffleHeader +' Raffle Completed',
                                                                detail: 'The '+ this.finishRaffleMsg +' raffle has concluded.' });

                this.formDisabled = true;
            });

    }

    validateWinners(): boolean {
        let validationSuccess = true;

        for (let i=0; i< this.winners.length; i++) {
            this.validateField('nameErr'+(i+1), 'name'+(i+1));
            this.validateTicketNumber('ticketErr'+(i+1), 'ticket'+(i+1), this.winners[i].TicketNumber);
            this.validateField('prizeErr'+(i+1), 'prize'+(i+1));

            if (Utils.isNullOrEmpty(this.winners[i].Name) || Utils.isNullOrEmpty(this.winners[i].Prize) || Utils.isNullOrEmpty(this.winners[i].TicketNumber)) {
                validationSuccess = false;
            }
        }

        const duplicateNumbers = Utils.findDuplicatesByPropertyValue(this.winners, 'TicketNumber');
        this.validateDuplicates(duplicateNumbers, 'ticket');

        if (this.isDraw || duplicateNumbers.length > 0) {
            validationSuccess = false;
        }

        return validationSuccess;
    }

    validateField(errElemId: string, elemId: string) {
        const elem = document.getElementById(elemId) ?? new HTMLElement() as any;
        const errElem = document.getElementById(errElemId) ?? new HTMLElement();

        if (!elem.value) {
            errElem.innerHTML =' This field is required';
            elem.style.border = '1px solid #E24C4C';
            errElem.style.display = 'block';
        }
        else {
            elem.style.border = '0.5px solid #0040604D';
            errElem.style.display = 'none';
        }
    }

    validateDuplicates(duplicatesArr: Winner[], fieldName: string) {
        for (const winner of duplicatesArr) {
            const elem = document.getElementsByClassName(fieldName+winner.Id)[0] as any;
            const errElem = document.getElementsByClassName(fieldName+'Err'+winner.Id)[0] as any;
            elem.style.border = '1px solid #E24C4C';
            errElem.innerHTML = 'Duplicate detected';
            errElem.style.display = 'block';
        }
    }

    validateName(errElemId: string, elemId: string, value: string = ''){
        this.validateField(errElemId, elemId);
        const duplicateNames = Utils.findDuplicatesByPropertyValue(this.winners, 'Name');
        this.validateDuplicates(duplicateNames, 'name');
    }

    validateTicketNumber(errElemId: string, elemId: string, value: string = '') {
        this.isTicketDraw(errElemId, elemId, value);
        this.validateField(errElemId, elemId);
    }

    isQuestsEnded() {
        const currentDate = new Date();
        const lastQuestDate = new Date(2025, 0, 5);
        return currentDate > lastQuestDate;
    }

    showRaffleSidebar() {
        if (!this.selectedDate || (this.timeSlice === TimeSliceEnum.GrandPrize && !this.isQuestsEnded())) {
            return;
        }
        this.showFinishRaffleSidebar = true;
    }

    closeRaffleSidebar() {
        this.showFinishRaffleSidebar = false;
    }

    addWinner() {
        const winner = new Winner();
        winner.Id = ++this.newWinnerID;
        this.winners.push(winner);
    }

    showSidebar() {
        if (!this.selectedDate) {
            return;
        }
        this.showExportSidebar = true;
    }

    isTicketDraw(errElemId: string, elemId: string, ticketNumber: string): void {
        if (!ticketNumber) {
            return;
        }
        this.questService.isTicketDraw({ TicketNumber: ticketNumber }, this.messageService).then(data => {
            if (!data) {
                const elem = document.getElementById(elemId) ?? new HTMLElement();
                const errElem = document.getElementById(errElemId) ?? new HTMLElement();
                errElem.innerHTML = 'This ticket does not exist';
                elem.style.border = '1px solid #E24C4C';
                errElem.style.display = 'block';
                return;
            }
            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            if (data.IsWinner) {
                this.isDraw = true;
                const elem = document.getElementById(elemId) ?? new HTMLElement();
                const errElem = document.getElementById(errElemId) ?? new HTMLElement();
                errElem.innerHTML = 'This ticket is already drawn';
                elem.style.border = '1px solid #E24C4C';
                errElem.style.display = 'block';
            } else {
                this.isDraw = false;
                const duplicateNumbers = Utils.findDuplicatesByPropertyValue(this.winners, 'TicketNumber');
                this.validateDuplicates(duplicateNumbers, 'ticket');
            }
        });

    }

    isWinnerChosen(): void {
        const dto = {
            StartDate: this.txnHeaderSearch.startDate,
            EndDate: this.txnHeaderSearch.endDate,
            TimeSlice: this.timeSlice
        };
        this.questService.isWinnerChosen(dto, this.messageService).then(data => {
            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            if (data && data.Winners && data.Winners.length > 0) {
                this.winners = data.Winners;
                if (this.winners.length === 15 && this.timeSlice === TimeSliceEnum.EarlyBird ||
                    this.winners.length === 5 && this.timeSlice === TimeSliceEnum.HolidayRush ||
                    this.winners.length === 2 && this.timeSlice === TimeSliceEnum.YearEndCraze ||
                    this.winners.length === 1 && this.timeSlice === TimeSliceEnum.GrandPrize) {
                    this.formDisabled = true;
                }
            } else {
                this.formDisabled = false;
                this.winners = [{Id: 1, Name: '', TicketNumber: '', Prize: ''} as Winner];
            }
        });

    }

    exportQuests() {
        if (!this.exportData.fileType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
            return;
        }

        this.exportLoading = true;
        this.questService.export(this.getRequestDto(0), this.messageService)
            .then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });
                Utils.saveFileResponse(data, this.fileName, this.exportData.fileType);
                this.exportLoading = false;
        })
            .catch(err => {
                this.exportLoading = false;
                throw err;
            });
    }

    getQuests(dto: any) {
        this.loading = true;
        this.questService.getQuests(dto, this.messageService).then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = dto.Skip;
                this.quests = data.Items;
                this.totalRecords = data.TotalRecords;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    fillDatesLists(questDates: any) {
        for (let i= 0; i < questDates.Days.length; i++) {
            this.daysList.push(
                { name: 'Day '+ (i+1) + ': ' + moment(questDates.Days[i]).format('MMMM D, YYYY'), value: questDates.Days[i] });
        }

        for (let i= 0; i < questDates.Weeks.length; i++) {
            const weekStartDate = questDates.Weeks[i];
            const weekEndDate = moment(weekStartDate).add(4,'days');
            this.weeksList.push({ name: 'Week '+ (i+1) + ': ' + moment(weekStartDate).format('DD') + '-'
                                                              + moment(weekEndDate).format('DD MMMM YYYY'), value: questDates.Weeks[i] });
        }

        for (const month of questDates.Months) {
            this.monthsList.push({ name: moment(month).format('MMMM YYYY'), value: month });
        }
    }

    onSelectionChange(event: any) {
        this.selectedQuest = event?.data;
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    getRequestDto(skip: number) {
        return {
            SearchName: this.searchName,
            Name: this.txnHeaderSearch.name ? this.txnHeaderSearch.name : '',
            ContactNumber: this.txnHeaderSearch.contactNumber ? this.txnHeaderSearch.contactNumber : '',
            Email: this.txnHeaderSearch.email ? this.txnHeaderSearch.email : '',
            TicketNumber: this.txnHeaderSearch.ticketNumber ? this.txnHeaderSearch.ticketNumber : '',
            StartDate: this.txnHeaderSearch.startDate ? moment(this.txnHeaderSearch.startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            EndDate: this.txnHeaderSearch.endDate ? moment(this.txnHeaderSearch.endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            FileType: this.exportData.fileType,
            TimeSlice: this.timeSlice,

            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
    }

    onChangeFilter() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getQuests(this.getRequestDto(0));
            this.searchTimer = 0;
        }, 1500);
    }

    protected readonly ExportFileTypeModel = ExportFileTypeModel;
    protected readonly TimeSliceEnum = TimeSliceEnum;
}

export class Winner {
    public Id: number = 0;
    public Name: string = '';
    public TicketNumber: string = '';
    public Prize: string = '';
}
